module.exports = __webpack_public_path__ + "f8e31ac02b68b96176a1b4fbb6475f35.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/components/InteractiveExample/de/2.m4a
// module id = 971
// module chunks = 4